import React from "react";

/**
 * Typographic monogram avatar used in place of founder photos.
 * Extracts initials from a full name and renders them on a subtle slate background
 * with a gold accent ring to match the brand palette.
 */
export const MonogramAvatar = ({ name, testId }) => {
  const initials = String(name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0].toUpperCase())
    .join("");

  return (
    <div
      data-testid={testId || "monogram-avatar"}
      className="w-24 h-24 rounded-full bg-slate-50 border border-slate-200 ring-4 ring-amber-500/10 flex items-center justify-center mx-auto mb-5 select-none"
      aria-label={`${name} monogram`}
    >
      <span className="font-extrabold text-2xl tracking-tight text-slate-900">
        {initials}
      </span>
    </div>
  );
};

export default MonogramAvatar;
